// Browser-side config loader, mirroring `@hobbyshopify/secrets`.
//
// `secrets` switches its source on `RUNNING_IN_DOCKER`: a local path during dev,
// `/secrets/...` inside Docker. This does the same for frontend config, but the
// browser can't read a Node env var — so the Docker signal and the values are both
// injected at container start into `public/config.js`, which assigns them onto
// `window`. That lets a single prebuilt bundle be configured per-environment
// without rebuilding.
//
//   - RUNNING_IN_DOCKER unset (local dev): read from Vite's `import.meta.env`,
//     inlined at build time from `.env` (only VITE_*-prefixed vars are exposed).
//   - RUNNING_IN_DOCKER set (Docker): read from `window.__APP_CONFIG__`, populated
//     by `public/config.js` (see `config.example.js`).
function inDocker() {
    return typeof window !== "undefined" && window.RUNNING_IN_DOCKER === "true";
}
/**
 * Read a single config value by key (e.g. `"VITE_FIREBASE_API_KEY"`).
 * Returns `undefined` if the key is not set in the active source.
 */
export function loadConfig(name) {
    if (inDocker()) {
        return window.__APP_CONFIG__?.[name];
    }
    // Accessing `import.meta.env` directly lets Vite inline it at build time.
    const env = import.meta.env;
    return env[name];
}
/**
 * Like {@link loadConfig} but throws if the value is missing — use for config
 * the app cannot start without.
 */
export function requireConfig(name) {
    const value = loadConfig(name);
    if (value === undefined || value === "") {
        const source = inDocker() ? "window.__APP_CONFIG__ (public/config.js)" : "import.meta.env";
        throw new Error(`Missing required config "${name}" (looked in ${source})`);
    }
    return value;
}
//# sourceMappingURL=index.js.map